import styled from 'styled-components'

export const Root = styled.div.attrs({
  id: 'root-loading'
})`
  position: fixed;
  z-index: 9999999;

  width: 100%;
`
